<template>
	<div :class="filterClass" class="filter table-filter--checkboxes">
		<dl class="filter__summary">
			<dt class="filter__summary__label" v-html="filterData.label"/>
			<dd v-if="filterValue" class="filter__summary__value" v-html="displayValue"/>
		</dl>
		<button v-if="filterValue" class="filter__clear" @click.prevent="clear()"><span>Clear filter</span>
		</button>
		<v-contextual-content ref="options" class="filter__options">
			<template v-slot:trigger="{ toggle }">
				<button v-if="!filterValue" class="filter__summary__set" @click.prevent="toggle()">
					<span>Show filter options</span></button>
				<button v-else class="filter__summary__clear" @click.prevent="toggle()"><span>Hide filter options</span>
				</button>
			</template>
			<h1 class="beta-up heavy">Filter by date</h1>
			<fieldset class="mt-2">
				<label><span class="sr-only">Date</span>
					<select v-model="form.data.date">
						<option selected value="created_at">Created</option>
						<option value="updated_at">Updated</option>
					</select>
				</label>
				<label><span class="sr-only">Type</span>
					<select v-model="form.data.type">
						<option selected value="is">is</option>
						<option value="between">is between</option>
						<option value="after">is on or after</option>
						<option value="before">is on or before</option>
					</select>
				</label>
				<label v-if="showStart"><span class="sr-only">Start</span>
					<v-dobpicker
						v-model="form.data.range.start"
						date-display-format="DD/MM/YYYY"/>
					<div class="help-block">
						<p>dd/mm/yyyy</p>
					</div>
				</label>
				<label v-if="showEnd"><span class="sr-only">End</span>
					<v-dobpicker
						v-model="form.data.range.end"
						date-display-format="DD/MM/YYYY"/>
					<div class="help-block">
						<p>dd/mm/yyyy</p>
					</div>
				</label>
			</fieldset>
			<ul class="actions actions--small-margin actions--vertical">
				<li>
					<button
						class="button button--primary button--small button--wide" @click.prevent="apply()">Apply
					</button>
				</li>
				<li v-if="filterValue">
					<button
						class="button button--secondary button--small button--wide"
						@click.prevent="clear()">Clear filter
					</button>
				</li>
			</ul>
		</v-contextual-content>
	</div>
</template>
<script>
import dayjs from "dayjs";

export default {
	data() {
		return {
			form: this.newForm({
				date: "created_at",
				type: "is",
				range: {
					start: "",
					end: "",
				},
			}),
			filterValue: null,
		};
	},

	computed: {
		filterClass() {
			return {
				"filter--has-filter": !!this.filterValue,
			};
		},
		showStart() {
			return this.form.data.type !== "before";
		},
		showEnd() {
			return ["between", "before"].indexOf(this.form.data.type) > -1;
		},
		displayValue() {
			if (!this.filterValue) {
				return null;
			}
			if (this.form.data.type === "between") {
				return [
					this.formatDate(this.form.data.range.start),
					this.formatDate(this.form.data.range.end),
				].join(" - ");
			}
			if (this.form.data.type === "before") {
				return "before " + this.formatDate(this.form.data.range.end);
			}
			if (this.form.data.type === "after") {
				return "after " + this.formatDate(this.form.data.range.start);
			}
			return this.formatDate(this.form.data.range.start);
		},
	},

	props: {
		filter: {
			required: true,
			type: Function,
		},
		filterData: {
			required: true,
			type: Object,
		},
	},

	methods: {
		formatDate(date) {
			return dayjs(date).format("DD/MM/YYYY");
		},
		apply() {
			this.filterValue = Object.assign({}, this.form.data);
			this.refs.options.toggle();
			this.filter("date", this.filterValue);
		},
		clear() {
			this.filterValue = null;
			this.form.reset();
			this.filter("date", this.filterValue);
		},
	},
};
</script>
